<template>
  <div ref="chart">
    <chart :height="height" :id="id" :option="option" :width="width" :route="route"></chart>
  </div>
</template>

<script>
import echarts from 'echarts';
import Chart from '@/components/echarts/Chart';

export default {
  name: "LineChart1",
  components: {Chart},
  props: {
    data: null,
    route: {
      type: String,
      default: ""
    },
  },
  data() {
    return {
      id: "lineChart1",
      width: '100%',
      height: '100%',
      option: {},
    };
  },
  mounted() {
    this.getOption()
  },
  watch: {
    data() {
      this.getOption();
    }
  },
  methods: {
    getOption: function () {
      let labelColor = 'rgba(73, 164, 243, .2)';
      this.option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        grid: {
          left: '15%',
          top: '15%',
          bottom: '18%',
          right: '10%',
        },
        legend: {
          type: "scroll",
          data: "告警数量",
          itemWidth: 18,
          itemHeight: 12,
          textStyle: {
            color: "#00ffff",
            fontSize: 14
          },
        },
        yAxis: [{
          type: 'value',
          position: 'left',
          nameTextStyle: {
            color: '#00FFFF'
          },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: labelColor
            }
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: labelColor,
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            formatter: '{value}',
            color: '#FAFAFA',
            fontSize: 12
          }
        },],
        xAxis: [{
          type: 'category',
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: labelColor,
            }
          },
          axisLabel: {
            // rotate: 30,
            show: true,
            textStyle: {
              color: '#FAFAFA', // x轴颜色
              fontWeight: 'normal',
              fontSize: 12,
              lineHeight: 22
            }
          },
          data: this.data[0],
        }],
        series: [{
          name: '告警数量',
          type: "line",
          data: this.data[1],
          itemStyle: {
            normal: {
              // borderWidth: 5,
              color: '#D06766',
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                  offset: 0,
                  color: 'rgba(208, 103, 102, 0.1)'
                }, {
                  offset: 1,
                  color: 'rgba(208, 103, 102, 1)'
                }]),
              }
            },
          }
        },
          {
            name: '告警数量',
            type: 'lines',
            coordinateSystem: 'cartesian2d',
            // symbolSize: 30,
            polyline: true,
            effect: {
              show: true,
              trailLength: 0,
              // symbol: "arrow",
              period: 10, //光点滑动速度
              symbolSize: 6,
            },
            lineStyle: {
              normal: {
                width: 1,
                opacity: 0.6,
                curveness: 0.2
              }
            },
            data: [{coords: this.data[2]}]
          }
        ],
      };
    },
  },
}
</script>

<style scoped>

</style>
